/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InfectedExcludePath } from '../models/InfectedExcludePath';

export class ListInfectedExcludePathsResponse {
  'paths': Array<InfectedExcludePath>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "paths",
      "baseName": "paths",
      "type": "Array<InfectedExcludePath>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInfectedExcludePathsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

